/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

const ChecklistOption = ({
  title,
  subTitle = '',
  isChecked = null,
  value,
  onSelected = null,
  withCheckbox = true,
  onClick = null,
  tag = null,
  tagColor = '',
  withArrow = false,
  withTrash = false,
  onIconClick = null,
  withIcon = null,
}) => {
  const _onClick = () => {
    if (onClick) onClick(value);
    else if (onSelected) {
      onSelected(value);
    }
  };

  return (
    <div
      className={`${
        isChecked ? 'bg-light' : 'bg-transparent'
      } rounded-3 py-3 px-4 border-transparent border cursor-pointer mb-2 d-flex flex-row align-items-center justify-content-between darken-disabled-hover`}
      onClick={_onClick}
      onKeyDown={null}
      role="button"
      tabIndex="0">
      <div className={`${subTitle ? '' : 'py-2'}`}>
        <div className="d-flex flex-row align-items-center">
          {withIcon}
          <span className={`${title?.length > 24 ? 'text-f6 ' : 'text-f5'} text-bold`}>
            {title}
          </span>
          {tag && <span className={`ms-2 text-f6 text-bold p-1 rounded-1 ${tagColor}`}>{tag}</span>}
        </div>
        {subTitle && (
          <>
            <div className="mb-2" />
            <p className="text-f6 text-shadow">{subTitle}</p>
          </>
        )}
      </div>
      {withCheckbox && (
        <input
          type="checkbox"
          className="form-check-input mt-2"
          checked={isChecked}
          onChange={onClick}
          required
        />
      )}
      {withArrow && (
        <i
          className="icon icon-arrow-next-navigation ms-auto text-primary"
          style={{ width: '1rem', height: '1rem' }}
        />
      )}
      {withTrash && (
        <i
          aria-label="trash click"
          onKeyDown={null}
          tabIndex={-1}
          role="button"
          onClick={onIconClick}
          className="icon icon-trash ms-auto text-shadow text-f4"
          style={{ width: '1rem', height: '1rem' }}
        />
      )}
    </div>
  );
};

export default ChecklistOption;
export { default as Checklist } from './container';

ChecklistOption.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  isChecked: PropTypes.bool,
  value: PropTypes.any.isRequired,
  onSelected: PropTypes.func,
  withCheckbox: PropTypes.bool,
  onClick: PropTypes.func,
  tag: PropTypes.string,
  tagColor: PropTypes.string,
  withArrow: PropTypes.bool,
  onIconClick: PropTypes.func,
  withTrash: PropTypes.bool,
  withIcon: PropTypes.any,
};
